var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/", role: "button" }
              },
              [_vm._v("\n                    back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.emailTemplate
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.updateEmailTemplate.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row justify-content-md-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("br"),
                    _vm._v(" "),
                    _c("legend", [_vm._v("Email Header")]),
                    _c("hr"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.mainHeading,
                              expression: "rules.mainHeading"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Main Heading",
                            placeholder: "Enter Template Main Heading",
                            "data-vv-name": "mainHeading",
                            "cus-name": "mainHeading",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.emailTemplate.mainHeading,
                            callback: function($$v) {
                              _vm.$set(_vm.emailTemplate, "mainHeading", $$v)
                            },
                            expression: "emailTemplate.mainHeading"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.imageUrl,
                              expression: "rules.imageUrl"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Main Image URL",
                            placeholder: "Enter URL",
                            "data-vv-name": "imageUrl",
                            "cus-name": "imageUrl",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.emailTemplate.imageUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.emailTemplate, "imageUrl", $$v)
                            },
                            expression: "emailTemplate.imageUrl"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.para1,
                              expression: "rules.para1"
                            }
                          ],
                          attrs: {
                            rows: "5",
                            type: "text",
                            label: "Enter First Paragraph",
                            placeholder: "Enter First Paragraph",
                            "data-vv-name": "para1",
                            "cus-name": "para1",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.emailTemplate.para1,
                            callback: function($$v) {
                              _vm.$set(_vm.emailTemplate, "para1", $$v)
                            },
                            expression: "emailTemplate.para1"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.para2,
                              expression: "rules.para2"
                            }
                          ],
                          attrs: {
                            rows: "5",
                            type: "text",
                            label: "Enter Second Paragraph",
                            placeholder: "Enter Second Paragraph",
                            "data-vv-name": "para2",
                            "cus-name": "para2",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.emailTemplate.para2,
                            callback: function($$v) {
                              _vm.$set(_vm.emailTemplate, "para2", $$v)
                            },
                            expression: "emailTemplate.para2"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("legend", [_vm._v("Email Template Sections")]),
                    _c("hr"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.commCoachingHeading,
                              expression: "rules.commCoachingHeading"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Common Coaching Heading",
                            placeholder: "Enter Common Coaching Heading",
                            "data-vv-name": "commCoachingHeading",
                            "cus-name": "commCoachingHeading",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.emailTemplate.commCoachingHeading,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.emailTemplate,
                                "commCoachingHeading",
                                $$v
                              )
                            },
                            expression: "emailTemplate.commCoachingHeading"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.commCoachingPara,
                              expression: "rules.commCoachingPara"
                            }
                          ],
                          attrs: {
                            rows: "5",
                            type: "text",
                            label: "Common Coaching Paragraph",
                            placeholder: "Enter Common Coaching Paragraph",
                            "data-vv-name": "commCoachingPara",
                            "cus-name": "commCoachingPara",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.emailTemplate.commCoachingPara,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.emailTemplate,
                                "commCoachingPara",
                                $$v
                              )
                            },
                            expression: "emailTemplate.commCoachingPara"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.liveEventHeading,
                              expression: "rules.liveEventHeading"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Live Event Heading",
                            placeholder: "Enter Live Event Heading",
                            "data-vv-name": "liveEventHeading",
                            "cus-name": "liveEventHeading",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.emailTemplate.liveEventHeading,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.emailTemplate,
                                "liveEventHeading",
                                $$v
                              )
                            },
                            expression: "emailTemplate.liveEventHeading"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.liveEventPara,
                              expression: "rules.liveEventPara"
                            }
                          ],
                          attrs: {
                            rows: "5",
                            type: "text",
                            label: "Live Event Paragraph",
                            placeholder: "Live Event Paragraph",
                            "data-vv-name": "liveEventPara",
                            "cus-name": "liveEventPara",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.emailTemplate.liveEventPara,
                            callback: function($$v) {
                              _vm.$set(_vm.emailTemplate, "liveEventPara", $$v)
                            },
                            expression: "emailTemplate.liveEventPara"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.customContentHeading,
                              expression: "rules.customContentHeading"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Custom Content Heading",
                            placeholder: "Enter Custom Content Heading",
                            "data-vv-name": "customContentHeading",
                            "cus-name": "customContentHeading",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.emailTemplate.customContentHeading,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.emailTemplate,
                                "customContentHeading",
                                $$v
                              )
                            },
                            expression: "emailTemplate.customContentHeading"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.customContentPara,
                              expression: "rules.customContentPara"
                            }
                          ],
                          attrs: {
                            rows: "5",
                            type: "text",
                            label: "Custom Content Paragraph",
                            placeholder: "Custom Content Paragraph",
                            "data-vv-name": "customContentPara",
                            "cus-name": "customContentPara",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.emailTemplate.customContentPara,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.emailTemplate,
                                "customContentPara",
                                $$v
                              )
                            },
                            expression: "emailTemplate.customContentPara"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.shareVideoHeading,
                              expression: "rules.shareVideoHeading"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Share Video Heading",
                            placeholder: "Enter Share Video Heading",
                            "data-vv-name": "shareVideoHeading",
                            "cus-name": "shareVideoHeading",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.emailTemplate.shareVideoHeading,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.emailTemplate,
                                "shareVideoHeading",
                                $$v
                              )
                            },
                            expression: "emailTemplate.shareVideoHeading"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.shareVideoPara,
                              expression: "rules.shareVideoPara"
                            }
                          ],
                          attrs: {
                            rows: "5",
                            type: "text",
                            label: "Share Video Paragraph",
                            placeholder: "Share Video Paragraph",
                            "data-vv-name": "shareVideoPara",
                            "cus-name": "shareVideoPara",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.emailTemplate.shareVideoPara,
                            callback: function($$v) {
                              _vm.$set(_vm.emailTemplate, "shareVideoPara", $$v)
                            },
                            expression: "emailTemplate.shareVideoPara"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: { type: "submit", disabled: _vm.errors.any() }
                    },
                    [
                      _vm._v(
                        "\n                        Update Email Template\n                    "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Configure Email Template")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48fb291a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48fb291a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/EmailTemplate.vue
// module id = ymPx
// module chunks = 0